import { Base64 } from 'js-base64';
const isJwtClaims = (payload)=>typeof payload === 'object' && payload != null;
export const decodeJwtPayload = (jwt)=>{
    const parts = jwt.split('.');
    if (parts.length !== 3) {
        return null;
    }
    try {
        const payload = JSON.parse(Base64.decode(parts[1]));
        return isJwtClaims(payload) ? payload : null;
    } catch (unused) {
        return null;
    }
};
